import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import SubHeader from '../components/SubHeader'
import Button from '../elements/Button'
import RemovableList from '../components/RemovableList'
import AjaxLoaderOverlay from '../components/AjaxLoaderOverlay'
import globals from '../globals'
import { TYPE_ALLOWED, TYPE_BLOCKED } from '../constants'

const AllowBlockWebsites = (props) => {
    const [allowedData, setAllowedData] = useState(props.serviceDetails.allowedUrls)
    const [blockedData, setBlockedData] = useState(props.serviceDetails.blockedUrls)
    const [isAdding, setIsAdding] = useState(false)
    const [addingError, setAddingError] = useState(false)
    const [inputUrl, setInputUrl] = useState('')

    const updateData = (data, onSuccess, onFailure = () => {}) => {
        DataSource.postData(
            '/api/postUpdateWebsiteLists',
            { ...data, serviceId: props.serviceId },
            response => {
                onSuccess(response)
            },
            error => {
                globals.handleError(
                    'Validation error occurred within AllowBlockWebsites.js when trying to update data list',
                    { data: data }
                )
                onFailure(error)
            })
    }

    const handleAdd = (event, type) => {
        event.preventDefault()
        setIsAdding(true)
        setAddingError(false)

        let allowedUpdatedData = [...allowedData]
        let blockedUpdatedData = [...blockedData]

        if (type === TYPE_ALLOWED) {
            allowedUpdatedData = [filterUrl(inputUrl), ...allowedData]
        } else {
            blockedUpdatedData = [filterUrl(inputUrl), ...blockedData]
        }

        updateData(
            { allowed: allowedUpdatedData, blocked: blockedUpdatedData, type: type },
            () => {
                globals.pushEvent(type === TYPE_ALLOWED ? 'AddAllowedSite' : 'AddBlockedSite', { value: inputUrl })
                setIsAdding(false)
                setInputUrl('')
                setAllowedData(allowedUpdatedData)
                setBlockedData(blockedUpdatedData)
                props.updateServiceDetails({
                    allowedUrls: allowedUpdatedData,
                    blockedUrls: blockedUpdatedData
                })
            }, response => {
                setIsAdding(false)
                if (response.response && response.response.status === 422) {
                    const errors = response.response.data.errors
                    setAddingError(errors[Object.keys(errors)[0]])
                } else {
                    setAddingError(true)
                }
            }
        )
    }

    const handleRemove = (updatedData, type) => {
        return new Promise((resolve, reject) => {
            let allowedUpdatedData = [...allowedData]
            let blockedUpdatedData = [...blockedData]

            if (type === TYPE_ALLOWED) {
                allowedUpdatedData = [...updatedData]
            } else {
                blockedUpdatedData = [...updatedData]
            }

            updateData(
                { allowed: allowedUpdatedData, blocked: blockedUpdatedData, type: type },
                () => {
                    resolve(() => {
                        if (type === TYPE_ALLOWED) {
                            setAllowedData(updatedData)
                        } else {
                            setBlockedData(updatedData)
                        }

                        props.updateServiceDetails({
                            allowedUrls: allowedUpdatedData,
                            blockedUrls: blockedUpdatedData
                        })
                    })
                },
                () => {
                    reject()
                }
            )
        })
    }

    const filterUrl = (url) => {
        return url.replace('http://', '').replace('https://', '').replace('www.', '')
    }

    return (
        <div className='module allow-block-websites'>
            <Heading title='Allow/block websites' />
            <ModuleWithLoader isLoaded className='py-4 px-3'>
                <div className='row'>
                    <div className='col-12 col-md-8 offset-md-2 text-center'>
                        <SubHeader
                            content='You can over-ride your category content filter settings here by allowing or blocking specific websites. If you know that a site is safe, you can always allow it here. Or if you definitely want a site blocked, this is the place.'
                            className='mb-5'
                        />
                    </div>
                </div>
                <div className='row mb-5 mb-lg-4'>
                    <div className='col-12 col-md-8 offset-md-2 text-center'>
                        <h2 className='m-0 mb-4 text-center'>Manage your own allow / block website lists</h2>
                        <div className='d-flex justify-content-center align-items-center position-relative flex-column flex-lg-row'>
                            <div className='input-container d-flex align-items-center justify-content-center'>
                                <div className='mr-1'>http://www.</div>
                                <input className='mr-lg-2' placeholder='your-url.com.au' style={{ width: '300px' }} value={inputUrl} onChange={e => setInputUrl(e.target.value)} />
                            </div>
                            <div className='mt-3 mt-lg-0'>
                                <Button title='Allow' action={event => handleAdd(event, TYPE_ALLOWED)} className='mr-2 btn-small gtm-hs-allow-site-url-add' />
                                <Button title='Block' action={event => handleAdd(event, TYPE_BLOCKED)} className='btn-small gtm-hs-block-site-url-add' />
                            </div>
                            <AjaxLoaderOverlay width='60px' doShow={isAdding} />
                        </div>
                        {addingError ? <div className='row-error mt-3'>{typeof addingError === 'boolean' ? 'Oops. Something went wrong, please try again.' : addingError}</div> : ''}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-md-10 offset-md-1 d-flex'>
                        <div className='row'>
                            <div className='col-12 col-lg-6 mb-4 mb-lg-0'>
                                <RemovableList
                                    key={allowedData.length}
                                    type={TYPE_ALLOWED}
                                    title='Allowed list'
                                    data={allowedData}
                                    handleRemove={handleRemove}
                                />
                            </div>
                            <div className='col-12 col-lg-6'>
                                <RemovableList
                                    key={blockedData.length}
                                    type={TYPE_BLOCKED}
                                    title='Blocked list'
                                    data={blockedData}
                                    handleRemove={handleRemove}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </ModuleWithLoader>
        </div>
    )
}

AllowBlockWebsites.propTypes = {
    serviceId: PropTypes.number.isRequired,
    serviceDetails: PropTypes.shape({
        allowedUrls: PropTypes.array,
        blockedUrls: PropTypes.array
    }).isRequired,
    updateServiceDetails: PropTypes.func.isRequired
}

export default AllowBlockWebsites



// WEBPACK FOOTER //
// ./resources/js/modules/AllowBlockWebsites.js